import React from "react";

interface CountDisplayProps {
  count: number;
  unit: string;
  icon: React.ReactNode;
}

export const CountDisplay: React.FC<CountDisplayProps> = ({ count, unit, icon }) => {
  return (
    <div className="flex items-end justify-center gap-1">
      <span className="mb-0.5">{icon}</span>
      <span className="text-2xl font-bold leading-none">{count}</span>
      <span className="mb-0.5 text-sm leading-none">{unit}</span>
    </div>
  );
};
